export const applicationRouteNames = {
  home: 'home',
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
};
